import * as React from 'react';
import ChooseInvestmentAmount from '../ChooseInvestmentAmount/ChooseInvestmentAmount';
import ChooseRiskLevel from '../ChooseRiskLevel/ChooseRiskLevel';
import IkeOrIkze from '../IkeOrIkze/IkeOrIkze';
import OpenIkeIkzeKorpo from '../OpenIkeIkzeKorpo/OpenIkeIkzeKorpo';
import SaveOrInvest from '../SaveOrInvest/SaveOrInvest';
import SelectFunds from '../SelectFunds/SelectFunds';
import SelectPath from '../SelectPath/SelectPath';
import SelectRecommendedFunds from '../SelectRecommendedFunds/SelectRecommendedFunds';
import SetAmountsPerFund from '../SetAmountsPerFund/SetAmountsPerFund';
import TransferIkeIkze from '../TransferIkeIkze/TransferIkeIkze';
import TransferIkzeEntrepreneur from '../TransferIkzeEntrepreneur/TransferIkzeEntrepreneur';

function calculateProgressByStepNumber(stepNumber: number): number {
  return 100 / 7 * stepNumber;
}

class Screen {
  static readonly SAVE_OR_INVEST = new Screen('save-or-invest',
      calculateProgressByStepNumber(1),
      SaveOrInvest);
  static readonly IKE_OR_IKZE = new Screen('ike-or-ikze',
      calculateProgressByStepNumber(2),
      IkeOrIkze);
  static readonly OPEN_IKE_KORPO = new Screen('open-ike-korpo',
      calculateProgressByStepNumber(3),
      OpenIkeIkzeKorpo);
  static readonly OPEN_IKZE_KORPO = new Screen('open-ikze-korpo',
      calculateProgressByStepNumber(3),
      OpenIkeIkzeKorpo);
  static readonly TRANSFER_IKE = new Screen('transfer-ike',
      calculateProgressByStepNumber(3),
      TransferIkeIkze);
  static readonly TRANSFER_IKZE = new Screen('transfer-ikze',
      calculateProgressByStepNumber(3),
      TransferIkeIkze);
  static readonly TRANSFER_IKZE_ENTREPRENEUR = new Screen('transfer-ikze-entrepreneur',
      calculateProgressByStepNumber(4),
      TransferIkzeEntrepreneur);
  static readonly SELECT_PATH = new Screen('select-path',
      calculateProgressByStepNumber(3),
      SelectPath);
  static readonly CHOOSE_RISK_LEVEL = new Screen('choose-risk-level',
      calculateProgressByStepNumber(4),
      ChooseRiskLevel);
  static readonly CHOOSE_INVESTMENT_AMOUNT = new Screen('choose-investment-amount',
      calculateProgressByStepNumber(5),
      ChooseInvestmentAmount);
  static readonly SELECT_RECOMMENDED_FUNDS = new Screen('select-recommended-funds',
      calculateProgressByStepNumber(6),
      SelectRecommendedFunds);
  static readonly SELECT_FUNDS = new Screen('select-funds',
      calculateProgressByStepNumber(5),
      SelectFunds);
  static readonly SET_AMOUNTS_PER_FUND = new Screen('set-amounts-per-fund',
      calculateProgressByStepNumber(6),
      SetAmountsPerFund);

  static readonly ALL = [
      Screen.SAVE_OR_INVEST,
      Screen.IKE_OR_IKZE,
      Screen.OPEN_IKE_KORPO,
      Screen.OPEN_IKZE_KORPO,
      Screen.TRANSFER_IKE,
      Screen.TRANSFER_IKZE,
      Screen.TRANSFER_IKZE_ENTREPRENEUR,
      Screen.SELECT_PATH,
      Screen.CHOOSE_RISK_LEVEL,
      Screen.CHOOSE_INVESTMENT_AMOUNT,
      Screen.SELECT_RECOMMENDED_FUNDS,
      Screen.SELECT_FUNDS,
      Screen.SET_AMOUNTS_PER_FUND,
  ];

  code: string;
  progress: number;
  component: React.ComponentType<any>;

  private constructor(code: string,
                      progress: number,
                      component: React.ComponentType<any>) {
    this.code = code;
    this.progress = progress;
    this.component = component;
  }
}

export default Screen;
